export default {"src":"/_next/static/media/img2.7aabe183.svg","height":201,"width":281,"blurWidth":0,"blurHeight":0};